import React, {useCallback, useRef} from 'react'
import {useIntl} from 'react-intl'
import {filterMessages} from 'components/Filters/filterMessages'
import {useFiltersForm} from 'hooks/useFiltersForm'

import {useDeviceLayout} from '@vio/atlas/context/deviceLayout'
import {Icon} from '@vio/atlas/Icon'
import {Pill} from '@vio/atlas/Pill'

const filterKeys = ['amenities']
const elementName = 'quickFilterAmenities'

interface Props {
  isActive?: boolean
}
export const BreakfastPill: React.FC<Props> = ({isActive = false}) => {
  const {formatMessage} = useIntl()
  const {isMobile} = useDeviceLayout()

  const buttonRef = useRef<HTMLButtonElement>(null)

  const {submitFilters, getAppliedFilters} = useFiltersForm(
    filterKeys,
    elementName
  )

  const {amenities = []} = getAppliedFilters()

  const handlePillClick = useCallback(() => {
    if (isActive) buttonRef.current?.blur()

    const updatedFilters = {
      amenities: isActive ? undefined : ['breakfast']
    }

    submitFilters(updatedFilters)
  }, [isActive, submitFilters])

  if ((!isMobile && isActive) || amenities.includes('allInclusive')) return null

  return (
    <Pill
      dataId="breakfastFilter"
      onClick={handlePillClick}
      isSelected={isActive}
      iconStart={<Icon name="Breakfast" />}
      iconEnd={isActive && <Icon name={'Close'} />}
    >
      {formatMessage(filterMessages.breakfast)}
    </Pill>
  )
}
